import { token } from '../di';
import { DIDStorage } from './didStorage.type';
import { DIDGenerator } from './didGenerator.type';

export const DEVICE_ID_STORAGE = token<DIDStorage>('DIDStorage');
export const DEVICE_ID_GENERATOR = token<DIDGenerator>('DIDGenerator');

export const tokens = {
  DEVICE_ID_STORAGE,
  DEVICE_ID_GENERATOR,
};
